import { makeActionHandler } from "./_reducerUtils";

export const surveyReducer = {
  initialState: {
    surveyType: {
      list: [],
      isLoaded: false
    },
    surveyTypeAndGroup: {
      list: [],
      isLoaded: false
    },
    surveyQuestion: {
      list: [],
      isLoaded: false
    },
    surveyRequestTemplate: {
      list: [],
      isLoaded: false
    },
    surveyRequestOverview: {
      list: [],
      isLoaded: false,
      selected: null
    },
    surveyByRespondent: {
      list: [],
      isLoaded: false,
      respondent: "",
      surveyRequestList: [],
      surveyAlertList: [],
      filter: {},
      isRefreshing: false
    },
    surveyResultSummary: {
      list: [],
      surveyTypeId: null,
      filter: {},
      isLoaded: false
    },
    surveyResultDetail: {
      employeeInfo: null,
      isLoaded: false,
      selectedYear: null,
      objectives: [],
      selectedEmployeeId: null
    },
    surveyResultHistory: {
      list: [],
      isLoaded: false
    }
  },
  handlers: {
    "survey/SET_SURVEY_TYPE": makeActionHandler("surveyType"),
    "survey/SET_SURVEY_TYPE_AND_GROUP": makeActionHandler("surveyTypeAndGroup"),
    "survey/SET_SURVEY_QUESTION": makeActionHandler("surveyQuestion"),
    "survey/SET_SURVEY_REQUEST_TEMPLATE": makeActionHandler(
      "surveyRequestTemplate"
    ),
    "survey/SET_SURVEY_REQUEST_OVERVIEW": makeActionHandler(
      "surveyRequestOverview"
    ),
    "survey/SET_SURVEY_BY_RESPONDENT": makeActionHandler("surveyByRespondent"),
    "survey/SET_SURVEY_RESULT_SUMMARY": makeActionHandler(
      "surveyResultSummary"
    ),
    "survey/SET_SURVEY_DETAIL": makeActionHandler("surveyResultDetail"),
    "survey/SET_SURVEY_RESULT_HISTORY": makeActionHandler(
      "surveyResultHistory"
    ),

    "survey/RESET_ALL": () => surveyReducer.initialState,
    "RESET_ALL": () => surveyReducer.initialState
  }
};

export default surveyReducer;
